import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const MissionTransportService = {

    async getPlanningValidated(){
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/`);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    }
    ,

    async filterPlanningValidated(formData, exportAll = false, includeReferences = true){
        try{
            const payload = {
                filterData: formData,
                include_references: includeReferences,
            };

            if (exportAll) {
                payload.export_all = true;
            }

            const result = await axios.post(
                `${apiUrl}/MissionTransport/filterPlanningValidated`,
                payload
            );
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async getagendaTransport(id) {
        try {
          const result = await axios.get(`${apiUrl}/MissionTransport/planningDestination/`+id);
          if (result) {
            return result.data;
          }
        }
        catch (error) {
          if (error.response) {
            return error.response.data;
          }
        }
      },
    
    async saveTransportMission(formData){
        try{
             const result = await axios.post(
        `${apiUrl}/MissionTransport`,
            formData
        );
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },

    async assignGlobalVehicleMission(formData){
        try{
            const result = await axios.post(
        `${apiUrl}/MissionTransport/assignVehicleMission`,
        formData
        );
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },

    async getVehicleCalendar(){
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/vehicleCalendar`);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async confirmTransportMission(missionId, agendaId = null){
        try{
            const result = await axios.put(
        `${apiUrl}/MissionTransport/setTransportStatus/`,
        {
            missionId:missionId,
            status:true,
            agendaId: agendaId
        })
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    }, 
    async activateTransportMission(missionId, agendaId = null){
        try{
            const result = await axios.put(
        `${apiUrl}/MissionTransport/setTransportStatus/`,
        {
            missionId:missionId,
            agendaId: agendaId,
            status:false
        })
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async sendDriverOM(missionId, agendaId = null, excludedTransportIds = []){
        try{
            const result = await axios.post(
        `${apiUrl}/MissionOrder/sendDriverOM/`,
        {
            mission_planning_id:missionId,
            mission_planning_agenda_id : agendaId,
            excluded_transport_ids: excludedTransportIds
        });
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },

    async detailEventCalendar(vhc_id, mission_planning_ids = []){
        try{
            const result = await axios.post(
        `${apiUrl}/MissionTransport/detailEventCalendar`, {
            vhc_id: vhc_id,
            mission_planning_ids: mission_planning_ids
        });
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    }, 

    async getDataMission(mission_planning_id){  
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/getDataMission/`+mission_planning_id);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async sendVehicleRequestDirection(formData){
        try{
            const result = await axios.post(
        `${apiUrl}/MissionTransport/sendVehicleRequestDirection`,
        formData
        );
            if (result) {
                return result.data;
            }

        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async getagendaTransportRequest(mission_planning_agenda_id){
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/planningDestinationRequest/`+mission_planning_agenda_id);
            if (result) {
                return result.data;
            }

        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }

    },
    async saveAxes(formData){
        try{
            const result = await axios.post(
        `${apiUrl}/MissionTransport/saveAxes`,
        {axesData: formData}
        );
            if (result) {
                return result.data;
            }

        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async getTransportData(transportId){
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/getTransportData/`+transportId);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async missionsByTranport(transportId){
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/missionsByTransport/`+transportId);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async transportsByMissionPlanning(mission_planning_id, mission_planning_agenda_id = null){
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/transportsByMissionPlanning?mission_planning_id=${mission_planning_id}&mission_planning_agenda_id=${mission_planning_agenda_id}`);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async removeTransportAssigned(transportId){
        try{
            const result = await axios.delete(
        `${apiUrl}/MissionTransport/removeTransportAssigned/`+transportId);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },
    async detachTransportAssigned(formData){
        try{
            const result = await axios.post(
        `${apiUrl}/MissionTransport/detachTransportAssigned`, formData);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
            return {
                status: false,
                message: 'Impossible de contacter le serveur.'
            };
        }
    },
    async transportationMode(){
        try{
            const result = await axios.get(
        `${apiUrl}/MissionTransport/transportationMode`);
            if (result) {
                return result.data;
            }
        }
        catch(error){
            if(error.response){
                return error.response.data;
            }
        }
    },

};

export default MissionTransportService;
